import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function About() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const RED = "#ff4b4b";

  return (
    <section id="about" className="container py-5" data-aos="fade-up">
      <h2 className="fw-bold mb-4">About Me</h2>
      <div className="row align-items-center">
        {/* Text Column (LEFT) */}
        <div className="col-lg-7">
          <div style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
            <p>
              <span role="img" aria-label="wave"></span> <strong>Hello, I'm Aryanil.</strong>
            </p>
            <p>
              Thank you for visiting my profile! If you're in a hurry, this section is for you.
            </p>
            <p>
              <span role="img" aria-label="rocket"></span> <strong>Professional Journey</strong>
            </p>
            <p>
              From enhancing machine learning models to optimize business operations to delivering detailed analysis, my work spans wide domains.
              <br />
              <span style={{ color: RED }}>Currently, I am working as an AI/ML Engineer.</span>
            </p>
            <p>
              <span role="img" aria-label="laptop"></span> <strong>Toolbox &amp; Expertise</strong>
            </p>
            <ul>
              <li><b>Programming:</b> Python, R, SQL, SAS, Git, HTML</li>
              <li><b>Data Visualization:</b> PowerBI, Excel, Plotly, Pandas, Matplotlib</li>
              <li><b>Machine Learning and Deep learning:</b> All ML models | CNN | RNN | LSTM | GAN | Auto{" "}Encoders</li>
              <li><b>Framework/Cloud:</b> Flask, AWS EC2, Amazon SageMaker, AWS S3, Docker, Django</li>
            </ul>
            <p>
              <span role="img" aria-label="handshake"></span> <strong>Let's Collaborate</strong>
            </p>
            <p>
              If you share a passion for data or want to collaborate, feel free to reach out!
            </p>
          </div>
        </div>

        {/* Image Column (RIGHT) */}
        <div className="col-lg-5 text-center mt-4 mt-lg-0">
          <img
            src="/assets/img/profile.jpg"
            alt="Aryanil profile"
            className="img-fluid"
            style={{
              maxWidth: 280,
              borderRadius: 28,
              border: `5px solid ${RED}`,
              boxShadow: `0 0 30px 8px ${RED}99`,
              transition: "box-shadow 0.4s cubic-bezier(0.4,1,0.7,0.8)",
              cursor: "pointer"
            }}
            onMouseEnter={e => {
              e.currentTarget.style.boxShadow = `0 0 40px 18px ${RED}CC`;
            }}
            onMouseLeave={e => {
              e.currentTarget.style.boxShadow = `0 0 30px 8px ${RED}99`;
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default About;
